module.exports = __webpack_public_path__ + "img/number.4874d07e.svg";